import { ITableColumn } from '@components/common/UTable/UTable';

import { UserStatus, UserStatusLabel } from '@/shared/users/enums';
import { RoleResponse } from '@/api/roles/types';

export const columns = (allRoles: RoleResponse[]) =>
  [
    {
      title: '№ п/п',
      dataIndex: 'index',
      width: 50,
    },
    {
      title: 'ФИО пользователя',
      dataIndex: 'fullName',
      key: 'fullName',
      sorter: true,
    },
    {
      title: 'Организация',
      dataIndex: 'organization.shortName',
    },
    {
      title: 'Роль',
      dataIndex: 'roleNames',
      type: 'select',
      payload: {
        options: allRoles,
        fieldNames: {
          label: 'description',
          value: 'name',
        },
      },
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (value: UserStatus) => UserStatusLabel[value],
    },
    {
      title: 'E-mail',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
    },
    {
      title: 'Дата создания',
      dataIndex: 'createdAt',
      key: 'createdAt',
      type: 'date',
      sorter: true,
    },
  ] as ITableColumn[];
